// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3tg4O","info":"UpdateTermsInfo_info__2F_Pk"};